<script setup lang="ts">
import SystemAlert from '@/app/system-alert/SystemAlert.vue'
import GlobalTinyMCEModal from '@/components/GlobalTinyMCEModal.vue'
import { useVuetifyDefault } from '@/modules/vuetify/useVuetifyDefault'
import { useLayout } from '@/composables/useLayouts/useLayout'
const { layout, currentLayout } = useLayout()

const { instance: vuetifyDefaults } = useVuetifyDefault();
/* example for switching layout */
/*const selectedSelectOption = ref<EVuetifyDefaults>(EVuetifyDefaults.DEFAULT)
watch(selectedSelectOption, (v:EVuetifyDefaults) => switchDefaults(v), { immediate: true})
*/
</script>
<template>
  <v-defaults-provider
    :defaults="vuetifyDefaults"
  >
    <v-app>
      <Suspense>
        <component :is="layout" v-memo="[currentLayout]">
          <router-view :key="$route.path"/>
        </component>
      </Suspense>
      <SystemAlert></SystemAlert>
      <GlobalTinyMCEModal></GlobalTinyMCEModal>
    </v-app>
  </v-defaults-provider>
</template>
